import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=96146b28&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=ts&"
export * from "./Mask.vue?vue&type=script&lang=ts&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=96146b28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96146b28",
  null
  
)

export default component.exports